import * as React from 'react'
import {graphql} from 'gatsby'
import {Picture, PictureData} from '../Picture'
import {renderRichText, RichTextReference} from '../ContentfulRichText'
import {ContentfulBlogPostPaginationData} from './ContentfulBlogPostPagination'
import {ContentfulBlogPostSocialShare} from './ContentfulBlogPostSocialShare'
import {usePageClass} from '../../utils/usePageClass'

export const query = graphql`
  fragment ContentfulBlogPost on ContentfulBlogPost {
    id
    slug
    published
    title
    author
    interviewer
    locale: node_locale
    description {
      description
    }
    image {
      ...Picture
    }
    body {
      raw
      references {
        __typename
        ... on ContentfulAsset {
          contentful_id
          ...Picture
        }
        ... on ContentfulBlogPostDownloadCta {
          contentful_id
          text {
            raw
          }
        }
      }
    }
    blog {
      ...ContentfulBlogPostPagination
    }
  }
`

export interface ContentfulBlogPostData {
  id: string
  title: string
  author?: string
  interviewer?: string
  description?: {
    description: string
  }
  locale: string
  image: PictureData
  published: string
  slug: string
  body: {
    raw: string
    references: RichTextReference[]
  }
  blog: ContentfulBlogPostPaginationData[]
}

export interface ContentfulBlogPostProps {
  data: ContentfulBlogPostData
  isAmp?: boolean
  path: string
}

export const ContentfulBlogPost: React.FC<ContentfulBlogPostProps> = ({data, path}) => {
  usePageClass('is-blog')

  const {locale, image, title, body, author, interviewer} = data
  const copy = {
    sv: {
      writtenBy: 'Text: ',
      interviewedBy: 'Intervju/research: ',
    },
    en: {
      writtenBy: 'Written by: ',
      interviewedBy: 'Interview/research: ',
    },
  }

  return (
    <>
      {image && <Picture data={image} alt={title} className="image" />}
      <article className="content blogpost has-gray-1-h1 has-gray-1-h3">
        {renderRichText({locale, richText: body.raw, references: body.references})}
      </article>
      <div className="blogpost-footer">
        {!!author && (
          <small>
            {copy[locale].writtenBy}
            {author}
          </small>
        )}
        {!!interviewer && (
          <small>
            {copy[locale].interviewedBy}
            {interviewer}
          </small>
        )}
      </div>
      <ContentfulBlogPostSocialShare data={data} href={`https://www.elsa.science${path}`} />
    </>
  )
}
